import {CashBackStatus} from '../api/getCashBackCards/cashBackCards.types';

const getCashBackHeaderText = (status: CashBackStatus): string => {
  switch (status) {
    case CashBackStatus.Inactive:
      return 'بعد از فعال شدن اعتبار بازگشتی می‌توانید از فروشگاه‌ مزرعه خرید کنید و یا وجه اعتبار را برداشت کنید.';
    case CashBackStatus.Active:
      return 'با استفاده از این اعتبار بازگشتی می‌توانید از فروشگاه‌ مزرعه خرید کنید و یا وجه اعتبار را برداشت کنید.';
    case CashBackStatus.RequestToWithdrawal:
      return 'درخواست برداشت وجه شما ثبت شد. بعد از واریز مبلغ به شما اطلاع رسانی میشود.';
    case CashBackStatus.Expired:
      return 'اعتبار بازگشتی شما منقضی شده است. شماره شبا حسابتان را جهت واریز وجه وارد کنید.';
    default:
      return 'داده های اعتبار بازگشتی شما مشکل دارند';
  }
};

export default getCashBackHeaderText;
